import React from 'react';
import {Provider} from "react-redux";

import { store } from "./main/store";
import Bootstrap from "./main/bootstrap";

import "./App.css";

const App = () => {
  return (
    <Provider store={store}>
      <Bootstrap/>
    </Provider>
  );
}



export default App;
